import React from "react";
import PropTypes from "prop-types";
import ModuleFactory from "components/psp/ModuleFactory/ModuleFactory";

import "./ModuleSection.scss";

export const toKebabCase = (text) => {
	if (typeof text !== "string") {
		return "";
	}
	return text.split(" ").splice(0, 4).join("-").toLowerCase();
};

export default function ModuleSection({
	title = "",
	modules = [],
	background,
	noPaddingBottom,
	noPaddingTop,
	noPadding,
	handleSearch = null
}) {
	const sectionId = toKebabCase(title);
	const safeModules = Array.isArray(modules) ? modules : [];

	return (
		<section
			className={`module-section ${sectionId} ${background ?? ""} ${
				noPaddingBottom ? "no-padding-bottom" : ""
			} ${noPaddingTop ? "no-padding-top" : ""} ${
				noPadding ? "no-padding" : ""
			}`}
			id={sectionId}
		>
			{safeModules.map((module, index) => {
				const moduleClasses = [];
				if (module.id) moduleClasses.push(toKebabCase(module.id));
				if (module.background) moduleClasses.push(module.background);
				return (
					<div
						// eslint-disable-next-line react/no-array-index-key
						key={`module-${index}`}
						className={moduleClasses.join(" ")}
					>
						<ModuleFactory
							type={module.type}
							props={module.props}
							handleSearch={handleSearch}
						/>
					</div>
				);
			})}
		</section>
	);
}

ModuleSection.propTypes = {
	modules: PropTypes.arrayOf(PropTypes.object),
	title: PropTypes.string,
	background: PropTypes.string,
	noPaddingBottom: PropTypes.bool,
	noPaddingTop: PropTypes.bool,
	noPadding: PropTypes.bool,
	handleSearch: PropTypes.func
};
